import http from 'axios'

export default {
  createLoginDetails: (loginDetails) =>
    http.post(`/web/v1/user/${loginDetails.username}/login-details`, loginDetails)
}
